// extracted by mini-css-extract-plugin
export default {"rowHighlight":"Documentation_rowHighlight__QsnT0"};